import IDSelectionComponent from "./IDSelection";
import RadioGroupControl from "./RadioGroup";
import { Field } from "react-final-form";
import TaxpayerDetails from "./TaxpayerDetails";
import DelegateDetails from "./DelegateDetails";
import { CaptureDetailsPrefixConstants } from "../../../models/Enums";
import { Box } from "@mui/material";

const TaxPractitionerDetails = () => {
  return (
    <>
      <IDSelectionComponent
        prefix={CaptureDetailsPrefixConstants.TaxPractitioner}
      />

      <TaxpayerDetails entityArray="taxPractitionerEntityType" />

      <Box>
        <Field
          name="radio-group-control"
          fullWidth
          component={RadioGroupControl}
          inputProps={{ wording: "Tax Practitioner" }}
        />
      </Box>

      <DelegateDetails />
    </>
  );
};

export default TaxPractitionerDetails;
